const TeapotPage = () => {
  return (
    <div className="mt-40 flex w-full items-center justify-center">
      <img src="/teapot.gif" alt="Teapot" style={{ width: "300px", height: "auto" }} />
    </div>
  );
};

export default TeapotPage;
